
$(function () {
  /*
   * 削除確認ダイアログ
   */
  $(document).on('click', '.delete-confirm-btn', function () {
    if (!confirm('削除しますがよろしいですか？\n削除前に戻すことはできませんのでご注意ください。')) {
      return false;
    }
    return true;
  });

});
